import _, { result } from 'underscore';
import { surveyStatus } from './survey-status';

const IS_SELENIUM = 'isselenium';

export const validateESCTriggerCondition = (survey, surveyTriggerName) => {
  survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, Start`);

  const isEnglishUser = result(survey.serverContext, ['CurrentUser', 'Language']) === 'EN';
  const isNotInternalUser = result(survey.serverContext, ['CurrentUser', 'IsInternal']) !== true;
  const isNotSupportUser = !result(survey.serverContext, ['CurrentUser', 'Name']).includes('@microsoftsupport.com');
  const isNotE2EMode = !window.navigator.webdriver;
  const isProdUrl = window.location.href.toLowerCase().includes('https://ui.ads.microsoft.com/');
  const isMcaUrl = window.location.href.toLowerCase().includes('campaign/mca');
  const isESCSurveyEnabled = window.location.href.includes('isESCSurveyEnabled=true');

  const qualtricsConditions =
    (survey.isTestEnv &&
      isESCSurveyEnabled) || // should be test env
    (isEnglishUser && // should be English user
      isNotInternalUser && // not internal users
      isNotSupportUser && // not support team users
      isNotE2EMode && // not test mode
      isProdUrl && // should be Prod URL
      isMcaUrl); // should be MCA URL

  if (!qualtricsConditions) {
    if (!isEnglishUser) {
      survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, qualtricsConditions: ${qualtricsConditions}, isEnglishUser: ${isEnglishUser}`);
      return false;
    }

    if (!isNotInternalUser) {
      survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, qualtricsConditions: ${qualtricsConditions}, isNotInternalUser: ${isNotInternalUser}`);
      return false;
    }

    if (!isNotSupportUser) {
      survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, qualtricsConditions: ${qualtricsConditions}, isNotSupportUser: ${isNotSupportUser}`);
      return false;
    }

    if (!isNotE2EMode) {
      survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, qualtricsConditions: ${qualtricsConditions}, isNotE2EMode: ${isNotE2EMode}`);
      return false;
    }

    if (!isProdUrl) {
      survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, qualtricsConditions: ${qualtricsConditions}, isProdUrl: ${isProdUrl}`);
      return false;
    }

    if (!isMcaUrl) {
      survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, qualtricsConditions: ${qualtricsConditions}, isMcaUrl: ${isMcaUrl}`);
      return false;
    }

    return false;
  }

  const isSurveyTriggerValid = result(window, ['survey', surveyTriggerName]);

  survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, ${isSurveyTriggerValid ? 'Pass' : 'Fail'}`);
  return isSurveyTriggerValid;
};

export const validateESCSignupTriggerCondition = (survey, surveyTriggerName) => {
  survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, Start`);

  const currentUser = result(survey.serverContext, ['CurrentUser']);
  const currentLocale = result(survey.serverContext, ['CurrentLocale']);
  let currentUserLanguage = result(survey.serverContext, ['CurrentUser', 'Language']);
  if (!currentUserLanguage && currentLocale.toLowerCase().indexOf('en') === 0) {
    currentUserLanguage = 'EN';
  }
  const isEnglishUser = currentUserLanguage === 'EN';
  const isNotInternalUser = result(survey.serverContext, ['CurrentUser', 'IsInternal']) !== true;
  const currentUserName = result(survey.serverContext, ['CurrentUser', 'Name']);
  const isNotSupportUser = currentUserName && !currentUserName.includes('@microsoftsupport.com');
  const isNotE2EMode = !window.navigator.webdriver;
  const isProdSignupUrl = window.location.href.toLowerCase().search(/ads\.microsoft\.com.*signup/) !== -1;
  const isESCSignupSurveyEnabled = window.location.href.includes('isESCSignupSurveyEnabled=true');

  const qualtricsConditions =
    (survey.isTestEnv &&
      isESCSignupSurveyEnabled) || // should be test env
    (currentUser &&
      isEnglishUser && // should be English user
      isNotInternalUser && // not internal users
      isNotSupportUser && // not support team users
      isNotE2EMode && // not test mode
      isProdSignupUrl) || // should be MCA sign up URL
    (!currentUser && // current user is not defined for new signups
      isEnglishUser && // should be English user
      isNotE2EMode && // not in E2E mode
      isProdSignupUrl); // should be MCA URL

  if (!qualtricsConditions) {
    if (!isEnglishUser) {
      survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, qualtricsConditions: ${qualtricsConditions}, isEnglishUser: ${isEnglishUser}`);
      return false;
    }

    if (!isNotInternalUser) {
      survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, qualtricsConditions: ${qualtricsConditions}, isNotInternalUser: ${isNotInternalUser}`);
      return false;
    }

    if (!isNotSupportUser) {
      survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, qualtricsConditions: ${qualtricsConditions}, isNotSupportUser: ${isNotSupportUser}`);
      return false;
    }

    if (!isNotE2EMode) {
      survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, qualtricsConditions: ${qualtricsConditions}, isNotE2EMode: ${isNotE2EMode}`);
      return false;
    }

    if (!isProdSignupUrl) {
      survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, qualtricsConditions: ${qualtricsConditions}, isMcaUrl: ${isProdSignupUrl}`);
      return false;
    }

    return false;
  }

  const isSurveyTriggerValid = result(window, ['survey', surveyTriggerName]);

  survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, ${isSurveyTriggerValid ? 'Pass' : 'Fail'}`);
  return isSurveyTriggerValid;
};

export const validateAdinsightRecommendationTriggerCondition = (survey, recommendationUrl, surveyPermission) => {
  survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, Start`);

  // should enable the pilot (pilot by percentage of user Id)
  const isPilotEnabled = result(survey.serverContext, ['Permissions', surveyPermission]);

  if (!isPilotEnabled) {
    survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, isPilotEnabled: ${isPilotEnabled}`);
    return false;
  }

  // should not be AAD users, AAD users can be included in the future after OCPS integration
  const isNonAADUser = !result(survey.serverContext, 'IsAADUser');

  if (!isNonAADUser) {
    survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, isNonAADUser: ${isNonAADUser}`);
    return false;
  }

  // should be active user more than 30 days
  const isUserActiveOneMonth =
    new Date(result(survey.serverContext, ['CurrentUser', 'CreatedDateTime'])) <= survey.SurveyPreferenceService.getDaysAgo(30);

  if (!survey.isTestEnv && !isUserActiveOneMonth) {
    survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, isTestEnv: ${survey.isTestEnv}, isUserActiveOneMonth: ${isUserActiveOneMonth}`);
    return false;
  }

  // trigger conditions
  const isEnglishUser = result(survey.serverContext, ['CurrentUser', 'Language']) === 'EN';
  const isNotInternalUser = result(survey.serverContext, ['CurrentUser', 'IsInternal']) !== true;
  const isNotSupportUser = !result(survey.serverContext, ['CurrentUser', 'Name']).includes('@microsoftsupport.com');
  const isNotE2EMode = !window.location.href.includes(IS_SELENIUM);
  const isDisabledInBVT = window.location.href.includes('Permissions.CSATSurveyInBVTDisabled=true');
  const isProdUrl = window.location.href.includes('https://ui.ads.microsoft.com/');
  const isRecommendationUrl = window.location.href.includes(recommendationUrl);

  const surveyConditions =
    (survey.isTestEnv && isRecommendationUrl && isNotE2EMode) || // should be test env
    (isEnglishUser && // should be English user
    isNotInternalUser && // not internal users
    isNotSupportUser && // not support team users
    !isDisabledInBVT && // should not be disabled in BVT
    isProdUrl && // should be Prod URL
    isRecommendationUrl); // should not be  URL

  if (!surveyConditions) {
    if (!isEnglishUser) {
      survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, surveyConditions: ${surveyConditions}, isEnglishUser: ${isEnglishUser}`);
      return false;
    }

    if (!isNotInternalUser) {
      survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, surveyConditions: ${surveyConditions}, isNotInternalUser: ${isNotInternalUser}`);
      return false;
    }

    if (!isNotSupportUser) {
      survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, surveyConditions: ${surveyConditions}, isNotSupportUser: ${isNotSupportUser}`);
      return false;
    }

    if (!isProdUrl) {
      survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, surveyConditions: ${surveyConditions}, isProdUrl: ${isProdUrl}`);
      return false;
    }

    if (!isRecommendationUrl) {
      survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, surveyConditions: ${surveyConditions}, isRecommendationUrl: ${isRecommendationUrl}`);
      return false;
    }

    return false;
  }

  survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, Pass`);

  return true;
};

export const validateAccountSettingsTriggerCondition = (survey, accountSettingUrl, surveyTriggerName) => {
  survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, Start`);

  // should not be AAD users, AAD users can be included in the future after OCPS integration
  const isNonAADUser = !result(survey.serverContext, 'IsAADUser');
  const isNotSupportUser = !result(survey.serverContext, ['CurrentUser', 'Name']).includes('@microsoftsupport.com');
  const isNotMicrosoftInternalUser = !result(survey.serverContext, ['CurrentUser', 'Name']).includes('@microsoft.com');

  // We let pass the case that the user is an AAD user and a support user
  if (!isNonAADUser && isNotSupportUser && isNotMicrosoftInternalUser) {
    survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, isNonAADUser: ${isNonAADUser}`);
    return false;
  }

  // trigger conditions
  const isNotE2EMode = !window.location.href.includes(IS_SELENIUM);
  const isProdUrl = window.location.href.includes('https://ui.ads.microsoft.com/');
  const isBetaProdUrl = window.location.href.includes('https://ui.beta.ads.microsoft.com/');
  const isAccountSettingUrl = window.location.href.includes(accountSettingUrl);

  const surveyConditions =
    (survey.isTestEnv && isAccountSettingUrl && isNotE2EMode) || // should be test env
    ((isProdUrl || isBetaProdUrl) && // should be Prod URL or Beta prod URL
    isAccountSettingUrl); // should be account setting URL

  if (!surveyConditions) {
    if (!(isProdUrl || isBetaProdUrl)) {
      survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, surveyConditions: ${surveyConditions}, isProdUrl: ${(isProdUrl || isBetaProdUrl)}`);
      return false;
    }

    if (!isAccountSettingUrl) {
      survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, surveyConditions: ${surveyConditions}, isAccountSettingUrl: ${isAccountSettingUrl}`);
      return false;
    }

    return false;
  }

  const isSurveyTriggerValid = result(window, ['survey', surveyTriggerName]);

  survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, ${isSurveyTriggerValid ? 'Pass' : 'Fail'}`);
  return isSurveyTriggerValid;
};

export const validateAssetLibraryTriggerCondition = (survey, surveyTriggerName, { checkPilot } = {}) => {
  survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, Start`);

  // pilot enabled
  const isPilotEnabled = checkPilot ? checkPilot() : result(survey.serverContext, ['Permissions', 'IsAssetLibrarySurveyEnabled']);

  if (!isPilotEnabled) {
    survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, isPilotEnabled: ${isPilotEnabled}`);
    return false;
  }

  // have added trigger flag in asset library page
  const isSurveyTriggerValid = result(window, ['survey', surveyTriggerName]);

  if (!isSurveyTriggerValid) {
    survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, isSurveyTriggerValid: ${isSurveyTriggerValid}`);
    return false;
  }

  // trigger conditions
  const isEnglishUser = result(survey.serverContext, ['CurrentUser', 'Language']) === 'EN';
  const isNotInternalUser = result(survey.serverContext, ['CurrentUser', 'IsInternal']) !== true;
  const isNotSupportUser = !result(survey.serverContext, ['CurrentUser', 'Name']).includes('@microsoftsupport.com');
  const isNotE2EMode = !window.location.href.includes(IS_SELENIUM);
  const isDisabledInBVT = window.location.href.includes('Permissions.CSATSurveyInBVTDisabled=true');
  const isProdUrl = window.location.href.includes('https://ui.ads.microsoft.com/');
  const isAssetLibrarySurveyEnabled = window.location.href.includes('isAssetLibrarySurveyEnabled=true');

  const surveyConditions =
    (survey.isTestEnv && isNotE2EMode && isAssetLibrarySurveyEnabled) || // should be test env
    (isEnglishUser && // English users
    isNotInternalUser && // not internal users
    isNotSupportUser && // not support team users
    !isDisabledInBVT && // should not be disabled in BVT
    isProdUrl); // should be Prod URL

  if (!surveyConditions) {
    if (!isEnglishUser) {
      survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, surveyConditions: ${surveyConditions}, isEnglishUser: ${isEnglishUser}`);
      return false;
    }

    if (!isNotInternalUser) {
      survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, surveyConditions: ${surveyConditions}, isNotInternalUser: ${isNotInternalUser}`);
      return false;
    }

    if (!isNotSupportUser) {
      survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, surveyConditions: ${surveyConditions}, isNotSupportUser: ${isNotSupportUser}`);
      return false;
    }

    if (!isProdUrl) {
      survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, surveyConditions: ${surveyConditions}, isProdUrl: ${isProdUrl}`);
      return false;
    }

    return false;
  }

  survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, Pass`);

  return true;
};

export const validateCopilotAssetRecommendationSatisfactionTriggerCondition = (survey, surveyTriggerName) => {
  survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, Start`);

  // have added trigger flag
  const isSurveyTriggerValid = result(window, ['survey', surveyTriggerName]);

  if (!isSurveyTriggerValid) {
    survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, isSurveyTriggerValid: ${isSurveyTriggerValid}`);
    return false;
  }

  // trigger conditions
  const isEnglishUser = result(survey.serverContext, ['CurrentUser', 'Language']) === 'EN';
  const isNotInternalUser = result(survey.serverContext, ['CurrentUser', 'IsInternal']) !== true;
  const isNotSupportUser = !result(survey.serverContext, ['CurrentUser', 'Name']).includes('@microsoftsupport.com');
  const isNotE2EMode = !window.location.href.includes('isselenium');
  const isDisabledInBVT = window.location.href.includes('Permissions.CSATSurveyInBVTDisabled=true');
  const isProdUrl = window.location.href.includes('https://ui.ads.microsoft.com/');

  const surveyConditions =
    (survey.isTestEnv && isNotE2EMode) || // should be test env
    (isEnglishUser && // English users
    isNotInternalUser && // not internal users
    isNotSupportUser && // not support team users
    !isDisabledInBVT && // should not be disabled in BVT
    isProdUrl); // should be Prod URL

  if (!surveyConditions) {
    window.survey.CopilotAssetRecommendationSatisfactionTrigger = false;
    if (!isEnglishUser) {
      survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, surveyConditions: ${surveyConditions}, isEnglishUser: ${isEnglishUser}`);
      return false;
    }

    if (!isNotInternalUser) {
      survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, surveyConditions: ${surveyConditions}, isNotInternalUser: ${isNotInternalUser}`);
      return false;
    }

    if (!isNotSupportUser) {
      survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, surveyConditions: ${surveyConditions}, isNotSupportUser: ${isNotSupportUser}`);
      return false;
    }

    if (!isProdUrl) {
      survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, surveyConditions: ${surveyConditions}, isProdUrl: ${isProdUrl}`);
      return false;
    }

    return false;
  }

  const surveyState = survey.SurveyPreferenceService.getSurveyState({ surveyName: survey.getSurveyName() });
  const { requiredModifyNumber = 10 } = surveyState || {};
  const currentRequiredModifyNumber = requiredModifyNumber - 1;

  survey.SurveyPreferenceService.setSurveyState({
    surveyName: survey.getSurveyName(),
    surveyState: {
      ...surveyState,
      requiredModifyNumber: currentRequiredModifyNumber,
    },
  });

  if (currentRequiredModifyNumber > 0) {
    window.survey.CopilotAssetRecommendationSatisfactionTrigger = false;
    survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, currentRequiredModifyNumber: ${currentRequiredModifyNumber}`);
    return false;
  }

  survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, Pass`);

  return true;
};

export const validateRSALLMOverallCallingAPI = (surveyName, apiCallingTime, status) => {
  const OVERALL_SURVEY_THRESHOLD = {
    [surveyStatus.INIT]: 10,
    [surveyStatus.FIRST_DISMISS]: 50,
    [surveyStatus.SECOND_DISMISS]: 100,
    [surveyStatus.THIRD_DISMISS]: 200,
    [surveyStatus.FOURTH_DISMISS]: 500,
    [surveyStatus.SUBMIT]: 500,
  };
  const MOSTWANTED_SURVEY_THRESHOLD = {
    [surveyStatus.INIT]: 50,
    [surveyStatus.FIRST_DISMISS]: 50,
    [surveyStatus.SECOND_DISMISS]: 100,
    [surveyStatus.THIRD_DISMISS]: 200,
    [surveyStatus.FOURTH_DISMISS]: 500,
    [surveyStatus.SUBMIT]: Number.MAX_VALUE, // Currently most wanted survey is never triggered when users submit the survey
  };
  const OVERALL_SURVEY_THRESHOLD_FAST_TRACK = {
    [surveyStatus.INIT]: 1,
    [surveyStatus.FIRST_DISMISS]: 1,
    [surveyStatus.SECOND_DISMISS]: 2,
    [surveyStatus.THIRD_DISMISS]: 3,
    [surveyStatus.FOURTH_DISMISS]: 4,
    [surveyStatus.SUBMIT]: 4,
  };
  const MOSTWANTED_SURVEY_THRESHOLD_FAST_TRACK = {
    [surveyStatus.INIT]: 1,
    [surveyStatus.FIRST_DISMISS]: 1,
    [surveyStatus.SECOND_DISMISS]: 2,
    [surveyStatus.THIRD_DISMISS]: 3,
    [surveyStatus.FOURTH_DISMISS]: 4,
    [surveyStatus.SUBMIT]: 4,
  };
  if (new URLSearchParams(window.location.search).get('IsFastTrackSurvey') === 'true') {
    const threshold = surveyName === 'RSALLMSuggestionOverallSurvey' ? OVERALL_SURVEY_THRESHOLD_FAST_TRACK : MOSTWANTED_SURVEY_THRESHOLD_FAST_TRACK;
    return !_.isUndefined(threshold[status]) ? apiCallingTime >= threshold[status] : false;
  }
  const threshold = surveyName === 'RSALLMSuggestionOverallSurvey' ? OVERALL_SURVEY_THRESHOLD : MOSTWANTED_SURVEY_THRESHOLD;
  return !_.isUndefined(threshold[status]) ? apiCallingTime >= threshold[status] : false;
};

export const validateRSALLMTriggerCondition = (survey) => {
  survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, Start`);

  // should be active user more than 30 days
  const isUserActiveOneMonth =
    new Date(result(survey.serverContext, ['CurrentUser', 'CreatedDateTime'])) <= survey.SurveyPreferenceService.getDaysAgo(30);

  if (!survey.isTestEnv && !isUserActiveOneMonth) {
    survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, isTestEnv: ${survey.isTestEnv}, isUserActiveOneMonth: ${isUserActiveOneMonth}`);
    return false;
  }

  // customize conditions for LLM OCV survey
  const surveyState = survey.SurveyPreferenceService.getSurveyState({ surveyName: survey.getSurveyName() });
  // if survey state is empty, usevalidateUserGovernance to get the default survey state
  if (_.isEmpty(surveyState)) {
    survey.validateUserGovernance();
  }
  const status = result(surveyState, 'status') || surveyStatus.INIT;

  const apiCallingTime = survey.getCallCountOfRSASuggestionAPI();
  const triggerCondition = validateRSALLMOverallCallingAPI(survey.getSurveyName(), apiCallingTime, status);

  // conditions
  const isNotSupportUser = !result(survey.serverContext, ['CurrentUser', 'Name']).includes('@microsoftsupport.com');
  const isNotE2EMode = !window.location.href.includes('isselenium');
  const isDisabledInBVT = window.location.href.includes('Permissions.CSATSurveyInBVTDisabled=true');
  const isProdUrl = window.location.href.includes('ads.microsoft.com');
  const isAdUrl = window.location.href.includes('campaign/vnext/ads');

  const qualtricsConditions =
    (survey.isTestEnv && isAdUrl && triggerCondition) || // should be test env
    (isNotSupportUser && // not support team users
    isNotE2EMode && // not E2E mode
    !isDisabledInBVT && // should not be disabled in BVT
    isProdUrl && // should be Prod URL
    isAdUrl && // should be Ad URL
    triggerCondition);

  if (!qualtricsConditions) {
    survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, qualtricsConditions: ${qualtricsConditions}, isTestEnv: ${survey.isTestEnv}, isNotSupportUser: ${isNotSupportUser}, isNotE2EMode: ${isNotE2EMode}, isProdUrl: ${isProdUrl}, isAdUrl: ${isAdUrl}`);
    return false;
  }

  survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, Pass`);
  return true;
};

export const validateAdsStudioTriggerCondition = (survey, surveyTriggerName, { checkPilot } = {}) => {
  survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, Start`);

  // pilot enabled
  const isPilotEnabled = checkPilot ? checkPilot() : result(survey.serverContext, ['Permissions', 'IsAdsStudioSurveyEnabled']);

  if (!isPilotEnabled) {
    survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, isPilotEnabled: ${isPilotEnabled}`);
    return false;
  }

  // have added trigger flag in ad studio page
  const isSurveyTriggerValid = result(window, ['survey', surveyTriggerName]);

  if (!isSurveyTriggerValid) {
    survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, isSurveyTriggerValid: ${isSurveyTriggerValid}`);
    return false;
  }

  // trigger conditions
  const isEnglishUser = result(survey.serverContext, ['CurrentUser', 'Language']) === 'EN';
  const isNotInternalUser = result(survey.serverContext, ['CurrentUser', 'IsInternal']) !== true;
  const isNotSupportUser = !result(survey.serverContext, ['CurrentUser', 'Name']).includes('@microsoftsupport.com');
  const isNotE2EMode = !window.location.href.includes(IS_SELENIUM);
  const isDisabledInBVT = window.location.href.includes('Permissions.CSATSurveyInBVTDisabled=true');
  const isProdUrl = window.location.href.includes('https://ui.ads.microsoft.com/');
  const isAdStudioSurveyEnabled = window.location.href.includes('isAdStudioSurveyEnabled=true');

  const surveyConditions =
    (survey.isTestEnv && isNotE2EMode && isAdStudioSurveyEnabled) || // should be test env
    (isEnglishUser && // English users
    isNotInternalUser && // not internal users
    isNotSupportUser && // not support team users
    !isDisabledInBVT && // should not be disabled in BVT
    isProdUrl); // should be Prod URL

  if (!surveyConditions) {
    if (!isEnglishUser) {
      survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, surveyConditions: ${surveyConditions}, isEnglishUser: ${isEnglishUser}`);
      return false;
    }

    if (!isNotInternalUser) {
      survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, surveyConditions: ${surveyConditions}, isNotInternalUser: ${isNotInternalUser}`);
      return false;
    }

    if (!isNotSupportUser) {
      survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, surveyConditions: ${surveyConditions}, isNotSupportUser: ${isNotSupportUser}`);
      return false;
    }

    if (!isProdUrl) {
      survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, surveyConditions: ${surveyConditions}, isProdUrl: ${isProdUrl}`);
      return false;
    }

    return false;
  }

  survey.logActivity(`validateTriggerCondition | survey: ${survey.getSurveyName()}, Pass`);

  return true;
};
